<template>
  <tooltip-icon placement="bottom" :openDelay="500">
      <div class="model-item-container" :class="{ 'on-select': onSelectMode,'has-error': item.statusCode < 0, 'has-pending': item.statusCode > 0 }"
         @click="onClickModelDetail">
      <div class="model-name">
        <span class="model-name-inner"><i v-if="item.password" class="el-icon-lock" style="font-size: 1.2rem; color: #6ba7ef;"></i> {{item.modelName}}</span>
      </div>
      <template v-if="item.type !== 'sx'">
        <div class="model-date">{{item.updatedAt | date_format('YYYYMMDDHHmmss', 'YYYY/MM/DD HH:mm')}}</div>
        <el-checkbox class="select-checkbox" :class="{ 'has-selected': selected }" ref="selectCheckbox"
                     v-model="selected" :label="false" v-if="isProtected(item)"></el-checkbox>
        <tooltip-icon placement="top" :content="modelStatusMessage" v-if="item.statusCode < 0">
          <i class="error el-icon-warning icon" @click.stop.prevent="onClickModelStatus"></i>
        </tooltip-icon>
        <tooltip-icon placement="top" :content="modelStatusMessage" v-if="item.statusCode > 0">
          <i class="pending el-icon-refresh icon" @click.stop="$emit('reload')"></i>
        </tooltip-icon>
        <el-dropdown size="medium" placement="bottom" style="position: absolute; top:0.5rem; right: 0.5rem;" v-if="isProtected(item)">
          <span class="el-dropdown-link" @click.stop.prevent="">
            <i class="more icon el-icon-more-outline"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item><p @click.stop.prevent="onModelNameChange">モデル名変更</p></el-dropdown-item>
            <el-dropdown-item divided><p @click.stop.prevent="onClickDelete" style="color: #d8243e;">モデル削除</p></el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </template>
      <template v-else>
        <div class="model-date">SkyFox標準モデル</div>
      </template>
    </div>
    <div slot="content" v-html="content"></div>
  </tooltip-icon>
</template>

<script>
import { ModelListItem } from '../../../defines/model/list'
import FormatUtil from '../../../utils/format'
import MessageBox from '../../../utils/message-box'
import CommonUtil from '../../../utils/common'

export default {
  name: 'ModelListItemCmp',
  props: {
    item: ModelListItem,
    onSelectMode: Boolean
  },
  data () {
    return {
      selected: false
    }
  },
  computed: {
    content () {
      let contents = []
      if (this.item.type !== 'sx') {
        contents.push(`\n作成者：${this.item.userName}\n学習データ：${this.item.uploadFileName}`)
      }
      if (CommonUtil.isNotEmpty(this.item.yName)) {
        contents.push(`\n予測対象：${this.item.yName}`)
      }
      if (CommonUtil.isNotEmpty(this.item.samples)) {
        contents.push(`\nデータ件数：${FormatUtil.formatNumber(this.item.samples)}件`)
      }
      if (CommonUtil.isNotEmpty(this.item.algorithmName)) {
        contents.push(`\nアルゴリズム：${this.item.algorithmName} (ver.${this.item.algorithmVersion})`)
      }
      return `<strong style="font-size: 1rem;">${FormatUtil.escapeHtml(
        this.item.modelName)}</strong>${FormatUtil.escapeHtml(contents.join(''), { nl2br: true })}`
    },
    modelStatusMessage () {
      switch (this.item.statusCode) {
          case 0:
            return ''
          case 1:
            return '作成中'
          case 2:
            return '更新中'
          case -1:
            return '作成失敗'
          case -2:
            return '更新失敗'
      }
    }
  },
  mounted () {
    if (CommonUtil.isNotNull(this.$refs.selectCheckbox)) {
      this.$refs.selectCheckbox.$el.querySelector('.el-checkbox__inner').addEventListener('click', this.onClickCheckbox)
    }
  },
  beforeDestroy () {
    if (CommonUtil.isNotNull(this.$refs.selectCheckbox)) {
      this.$refs.selectCheckbox.$el.querySelector('.el-checkbox__inner')
        .removeEventListener('click', this.onClickCheckbox)
    }
  },
  methods: {
    isProtected (model) {
      return model.statusCode === 0 && !model.password
    },
    onClickCheckbox (event) {
      event.stopPropagation()
      event.preventDefault()
      this.selected = !this.selected
      this.$forceUpdate()
      if (this.selected) {
        this.$emit('selected', this)
      } else {
        this.$emit('deselected', this)
      }
    },
    onClickModelDetail () {
      if (this.item.statusCode === 0 && !this.onSelectMode) {
        const password = this.item.password
        if (password) {
          const message = `このモデルにはパスワードが設定されています<br><br>パスワードを入力：`
          MessageBox.passwordConfirm(this, message, password
          ).then(() => {
            this.$emit('detail', this.item)
          }).catch(() => {
          })
        } else {
          this.$emit('detail', this.item)
        }
      }
    },
    onModelNameChange () {
      const modelName = FormatUtil.escapeHtml(this.item.modelName)
      const message = `モデル「<b>${modelName}</b>」の名前を変更します<br><br>新しいモデル名を入力：`

      MessageBox.modelNameChangeConfirm(this, message, modelName
      ).then((input) => {
        this.$emit('putModelName', this.item, input.value)
      }).catch(() => {})
    },
    onClickDelete (event) {
      const modelName = FormatUtil.escapeHtml(this.item.modelName)
      const password = this.item.password

      let key = ''
      let message = ''
      let errorMessage = ''

      if (password) {
        key = password
        message = `モデル「<b>${modelName}</b>」を削除します<br>(モデルを削除すると適用結果も削除されます)<br><br>削除の確認のため、パスワードを入力：`
        errorMessage = 'パスワードが違います'
      } else {
        key = modelName
        message = `モデル「<b>${modelName}</b>」を削除します<br>(モデルを削除すると適用結果も削除されます)<br><br>削除の確認のため、モデル名を入力：`
        errorMessage = 'モデル名が違います'
      }

      MessageBox.deleteModelConfirm(this, message, key, errorMessage
      ).then(() => {
        this.$emit('delete', this.item)
      }).catch(() => {})
    },
    onClickModelStatus (event) {
      const message = (this.item.statusCode === -1)
        ? 'モデルが作成できませんでした。データは削除されます。\n原因不明の場合はお問合せください。' : 'モデルが更新できませんでした。更新前のモデルに戻ります。\n原因不明の場合はお問合せください。'
      MessageBox.confirm(this, FormatUtil.escapeHtml(message), {
        dangerouslyUseHTMLString: true
      }).then(() => {
        this.$emit('confirmed-error', this.item)
      }).catch(() => {})
    }
  }
}

</script>

<style scoped>
  .model-item-container {
    width: 252px;
    height: 152px;
    border: 1px solid #c0d5ef;
    border-radius: 2px;
    padding: 0;
    margin-right: 24px;
    margin-bottom: 24px;
    display: flex;
    flex-direction: column;
    position: relative;
  }

  .model-item-container:not(.has-error):not(.has-pending):not(.on-select):hover {
    background-color: #f1f9ff;
    cursor: pointer;
  }

  .model-name {
    display: flex;
    align-items: flex-end;
    justify-content: center;
    height: 80px;
    padding: 0 16px;
    font-weight: normal;
  }

  .model-name-inner {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    text-align: center;
  }

  .model-date {
    text-align: center;
    font-size: 0.8rem;
  }

  .error {
    color: #d8243e;
  }

  .pending {
    color: #2456d4;
  }

  .model-item-container .more.icon {
    visibility: hidden;
    font-size: 1.6rem;
    color: #2456d4;
  }

  .error,
  .pending {
    position: absolute;
    top: 3px;
    left: 3px;
  }

  .model-item-container .icon {
    font-size: 1.5rem;
    cursor: pointer;
    opacity: 1.0;
  }

  .model-item-container .icon:hover {
    opacity: 0.7;
  }

  .model-item-container .select-checkbox {
    position: absolute;
    top: 6px;
    left: 10px;
    visibility: hidden;
    margin: 0;
  }

  .model-item-container:not(.has-error):not(.has-pending):not(.on-select):hover .select-checkbox,
  .model-item-container:not(.has-error):not(.has-pending):not(.on-select):hover .icon.delete,
  .model-item-container:not(.has-error):not(.has-pending):not(.on-select):hover .icon.more {
    visibility: visible;
  }

  .model-item-container.on-select .select-checkbox {
    visibility: visible;
  }

  .model-item-container.on-select {
    background: #abb5bf;
    cursor: default;
  }
</style>



// WEBPACK FOOTER //
// src/components/model/list/item.vue